import { faAndroid, faAppStore, faWindows } from '@fortawesome/free-brands-svg-icons';
import { faDesktop, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
// import AdContainer from '../AdContainer';
import './Home.css';

function Home() {
  return (
        <section className="pandora-home">
        <figure className='pandora-icons'>
        <FontAwesomeIcon icon={faAppStore} size="2x" />
        <FontAwesomeIcon icon={faWindows} size="2x" />
        <FontAwesomeIcon icon={faAndroid} size="2x" />
        <FontAwesomeIcon icon={faDesktop} size="2x" />
        <FontAwesomeIcon icon={faMobileAlt} size="2x" />

        </figure>
            <h2>Repeatable creation and growth of successful products and businesses.</h2>
            {/* <main> */}
            {/* <AdContainer /> */}
            {/* </main> */}
        </section>
  )
}

export default Home